import { connect } from "react-redux";
import ViewReportPmSites from "./viewReportPmSites";
import { bindActionCreators } from "redux";
import { pmSiteViewReport, postGenerateReport,postRejectPmSite,pmSiteReportDownload,postApprovePmSite } from "services/redux/maintenance/pmSities/action";
import {
  getPocBySiteId,
} from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
  pmReportData: state.pmSitiesReducer.pmReportData,
  pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      pmSiteViewReport,
      getPocBySiteId,
      postGenerateReport,
      pmSiteReportDownload,
      postRejectPmSite,
      postApprovePmSite,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewReportPmSites);
